import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, onMounted, computed } from 'vue';
import { PropType } from 'vue'
import tools from '@/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'Cascader',
  props: {
  label: {
    type: String,
    default: '级联选择器'
  },
  rules: Array,
  value: [String, Number],
  options: {
    type: Array as PropType<{ text: string, value: number }[]>,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:value'],
  setup(__props, { emit }) {

const props = __props

onMounted(() => {

})

const Options = ref({
  name: '级联选择'
})





const result = computed(() => {
  if (props.value) {
    const pathData = tools.j4tools.getNodePath(props.options, props.value, { idKey: 'value', parentIdKey: 'parentid', childrenKey: "children" })
    if (pathData.length > 0) {
      return pathData.map((option) => option.text).join('/');
    }
  }
})

const visible = ref(false)
const onShow = () => {
  if (!props.disabled) {
    visible.value = true
  }
}

const data = ref('')

const onFinish = ({ selectedOptions }: any) => {
  console.log(selectedOptions)
  console.log(data.value)
  emit('update:value', data.value)
  visible.value = false
};


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cascader = _resolveComponent("van-cascader")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, {
      modelValue: _unref(result),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(result) ? (result).value = $event : null)),
      "is-link": !props.disabled,
      readonly: "",
      label: __props.label,
      placeholder: __props.label,
      rules: __props.rules,
      disabled: props.disabled,
      onClick: onShow
    }, null, 8, ["modelValue", "is-link", "label", "placeholder", "rules", "disabled"]),
    _createVNode(_component_van_popup, {
      show: visible.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cascader, {
          modelValue: data.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data).value = $event)),
          title: __props.label,
          options: __props.options,
          disabled: props.disabled,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
          onFinish: onFinish
        }, null, 8, ["modelValue", "title", "options", "disabled"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})